import { NecCopyrightComponent } from './footer/footer-link/copyright.component';
import { NecDisclaimerComponent } from './footer/footer-link/disclaimer.component';
import { NecHomeComponent } from './home/home/home.component';
import { NecLoginComponent } from './login/login.component';
import { NecMoocInfoComponent } from './home/mooc-info/mooc-info.component';
import { NecMoocTestComponent } from './home/mooc-test/mooc-test.component';
import { NecMoreInfoComponent } from './home/more-info/more-info.component';
import { NecPrivacyComponent } from './footer/footer-link/privacy.component';
import { NecXiaoXiangComponent } from './home/xiao-xiang/xiao-xiang.component';
import { Routes } from '@angular/router';


export const CommonComponentRoutes: Routes = [
  {
    path: 'login',
    component: NecLoginComponent
  },
  {
    path: 'home',
    component: NecHomeComponent,
  },
  {
    path: 'more-info',
    component: NecMoreInfoComponent
  },
  {
    path: 'mooc-info',
    component: NecMoocInfoComponent
  },
  {
    path: 'mooc-test',
    component: NecMoocTestComponent
  },
  {
    path: 'xiao-xiang',
    component: NecXiaoXiangComponent
  },
  {
    path: 'copyright',
    component: NecCopyrightComponent
  },
  {
    path: 'privacy',
    component: NecPrivacyComponent
  },
  {
    path: 'disclaimer',
    component: NecDisclaimerComponent
  }
];
